/*eslint-disable react/jsx-key */
import React, { useEffect, useMemo } from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
//import './index.scss';
import { useNavigate } from 'react-router-dom';
import CustomClientError from 'src/Admin/errorhandling/CustomClientError';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const ClaimsTable = ({
  columns,
  data,
  pageSizeCount,
  dataFetching,
  labelProp = 'My Claims',
  //customSortingHandler,
  sortByColumn,
  serverSideSorting,
}) => {
  console.log(data, 'data before display');
  console.log(columns);

  const navigate = useNavigate();
  //Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    page,
    setPageSize,
    pageCount,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      initialState: {
        pageIndex: 0,
        pageSize: pageSizeCount,
        sortBy: [sortByColumn],
      },
      manualSortBy: true,
    },
    useSortBy,
    usePagination,
  );

  useEffect(() => {
    //customSortingHandler(sortBy[0]?.id, sortBy[0]?.desc, sortBy);
    serverSideSorting(sortBy); //implement server side sorting
  }, [sortBy]);

  const onClick = (ele) => {
    if (ele) {
      console.log(ele, 'PageRedirect');
      navigate(`/admin/claim-details?trx=${ele}`);
    }
  };
  useMemo(() => {
    setPageSize(pageSizeCount);
  }, [pageSizeCount]);
  //Render the UI for your table
  return (
    <div>
      <table className="table padding-mobile-0" {...getTableProps()}>
        {data?.length > 0 && !dataFetching && (
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(
                      column.getSortByToggleProps({ title: undefined }),
                    )}
                    className={
                      column.isSorted ? 'coloumnIsSorted' : 'coloumnNotSorted'
                    }
                  >
                    <b>{column.render('Header')}</b>
                    <span
                      className={
                        column.isSorted
                          ? column.isSortedDesc
                            ? 'arrowDown'
                            : 'arrowUp'
                          : 'arrowNormal'
                      }
                    ></span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
        )}

        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell, index) => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      onClick={() => onClick(row.original.ClaimOid)}
                    >
                      <p className="claims-data">
                        {index === 6 || index === 7 || index === 8 ? (
                          cell.value != -1 ? (
                            cell.value ? (
                              formatter.format(cell.value)
                            ) : (
                              '---'
                            )
                          ) : (
                            '---'
                          )
                        ) : index === 3 ? (
                          <span className="text-decoration-underline">
                            {cell.render('Cell')}
                          </span>
                        ) : (
                          cell.render('Cell')
                        )}
                      </p>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
      {data?.length === 0 && !dataFetching && (
        <div className="claims-no-data text-center">
          <CustomClientError
            CustomClasses="p-0 m-0"
            ErrorHeading="No Claims found!"
            ErrorMessage="We could not find any Claims for the selected filter(s).
            Use another filter(s) and try again."
          />
        </div>
      )}
    </div>
  );
};

export default ClaimsTable;
